import React from 'react';

import Button from 'components/Button';
import Image from 'components/Image';
import Message from 'components/Message';
import Typography from 'components/Typography';

import { convertAndFormatDate } from 'helpers/date';

import { useAuth } from 'hooks/useAuth';

import check from 'assets/images/round-check.svg';
import './style.scss';
interface iProps {
  titleId: string;
  messageId: string;
}

const SubscriptionCancelInformation = ({ titleId, messageId }: iProps) => {
  const { activeSubscription } = useAuth();

  const expiresAt =
    activeSubscription && convertAndFormatDate(activeSubscription.expiresAt);

  return (
    <div className="SubscriptionCancelInformation">
      <div className="SubscriptionCancelInformation__header">
        <Image
          src={check}
          alt={{
            id: 'components.SubscriptionCancelInformation.NoConnection.alt',
          }}
        />

        <Typography className="title" variant="h1">
          <Message message={{ id: titleId }} />
        </Typography>
        <Message
          message={{
            id: messageId,
            values: {
              expiresAt: <b>{expiresAt}</b>,
            },
          }}
        />
      </div>
      <div className="SubscriptionCancelInformation__cta">
        <Button
          linkTo="/browse"
          variant="primary"
          title={{ id: 'containers.SubscriptionCancel.CTA' }}
        />
      </div>
    </div>
  );
};

export const CancelConfirmation = () => (
  <SubscriptionCancelInformation
    titleId="containers.SubscriptionCancel.CancelConfirmation.title"
    messageId="containers.SubscriptionCancel.CancelConfirmation.message"
  />
);

export const PromoApplied = () => (
  <SubscriptionCancelInformation
    titleId="containers.SubscriptionCancel.PromoApplied.title"
    messageId="containers.SubscriptionCancel.PromoApplied.message"
  />
);
